import React from 'react'
import TagFinder from './TagFinder'
import LinkBuilder from './LinkBuilder'
import { Link } from 'react-router-dom';

const SectionWidgetUnit = ({key, list, num, title, description, url, date, tags}) => {
    
    const sectionGrid = (
        <div className="section-unit-content">
            <div className="section-unit-header">
                <p>{"#" + num}</p>
                <p>{date}</p>
            </div>
            <div className="section-unit-body">
                <div className="section-unit-title">
                    <h3>{title}</h3>
                </div>
                <div className="section-unit-description">
                    <p>{description}</p>
                </div>
            </div>
            <div className="section-unit-footer">
                <TagFinder num={tags}/>
                <div className="section-unit-arrow-container">  
                    <img alt="visit" src="/icons/sector-unit-arrow.svg"/>
                </div>
            </div>
        </div>
    )

    const sectionList = (
        <div className="section-unit-content">
            <div className="section-unit-header list-style">
                <p>{"#" + num}</p>
                <p>{date}</p>
                <TagFinder num={tags}/>
            </div>
            <div className="section-unit-footer list-style">
                <div className="section-unit-body">
                    <div className="section-unit-title list-style">
                        <h3>{title}</h3>
                    </div>
                    <div className="section-unit-description list-style">
                        <p>{description}</p>
                    </div>
                </div>
                <div className="section-unit-arrow-container">  
                    <img alt="visit" src="/icons/sector-unit-arrow.svg"/>
                </div>
            </div>
        </div>
    )

    return (
        <div className={list ? "section-unit-container grid-style" : "section-unit-container list-style"}>
            <Link className="section-unit-container-link noHover" to={LinkBuilder(url)}>
                {list ? sectionGrid : sectionList}
            </Link>
        </div>
    )
}

export default SectionWidgetUnit;
